export default __webpack_public_path__ + "static/media/LA_VOZ_TX.8f061dd4.png";